import {Component, Input, OnChanges} from '@angular/core';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {StudentService} from '../../services/student.service';
import {StudentDto} from '@sidr/dto-types';

@Component({
  selector: 'app-student-information',
  templateUrl: './student-information.component.html',
  styleUrls: ['./student-information.component.scss']
})
export class StudentInformationComponent implements OnChanges {
  student: StudentDto;
  @Input() districtId: string;
  @Input() studentId: string;
  loading: boolean;
  @Input()
  printOptions: PrintOptions;

  constructor(
    private studentService: StudentService
  ) {
    this.loading = false;
  }

  getData() {
    if (!this.districtId || !this.studentId) {
      return;
    }
    this.loading = true;
    this.studentService.get(this.districtId, this.studentId).subscribe(r => {
      this.student = r;
      this.loading = false;
    }, (err) => {

    }, () => {
      this.loading = false;
    });
  }

  ngOnChanges() {
    this.getData();
  }
}
